module.exports = __webpack_public_path__ + "static/media/sec2@3x.ae383e47.png";